<template>
  <div class="regist">
    <div class="regist-bg"></div>
    <div class="regist-wrapper fullscreen-center">
      <!-- 注册 -->
      <div class="regist-content" v-if="is_login">
        <div class="header">
          <div class="pcm-icon">
            <img src="@images/icon/bn02_01.jpg" alt="" />
          </div>
          <div class="regist-title">{{ phone_title }}</div>
        </div>

        <el-form
          :ref="ref_regist_form"
          :rules="rules"
          label-position="left"
          class="form-regist regist-form"
          :model="regist_model"
          label-width="40px"
        >
          <el-form-item label prop="mobilePhone" class="border-bottom">
            <span slot="label" style="width: 40px">
              <div class="form-icon">
                <img src="@images/icon/tel@2x.png" alt />
              </div>
            </span>
            <el-input
              @keyup.enter.native="regist()"
              v-model="regist_model.mobilePhone"
              placeholder="请输入手机号"
            />
          </el-form-item>
          <el-form-item label prop="code" class="border-bottom">
            <span slot="label" style="width: 40px">
              <div class="form-icon">
                <img src="@images/icon/psd@2x.png" alt />
              </div>
            </span>
            <el-input
              @keyup.enter.native="regist()"
              v-model="regist_model.code"
              placeholder="请输入验证码"
              class="code_input"
            >
              <template slot="append">
                <el-button
                  class="send-code-btn"
                  type="primary"
                  :loading="isSend"
                  @click="sendCode()"
                >
                  {{ sendCodeText }}
                </el-button>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item label prop="password" class="border-bottom">
            <span slot="label" style="width: 40px">
              <div class="form-icon">
                <img src="@images/icon/psd@2x.png" alt />
              </div>
            </span>
            <el-input
              type="password"
              v-model="regist_model.password"
              placeholder="请输入密码"
            />
          </el-form-item>
          <!--<el-form-item label prop="_password"  class="border-bottom">
						<span slot="label" style="width: 40px;">
              <div class="form-icon">
                <img src="@images/icon/psd@2x.png" alt />
              </div>
            </span>
						<el-input
							@keyup.enter.native="registAccount"
							type="password"
							v-model="regist_model._password"
							placeholder="请再次输入密码"
						/>
					</el-form-item>-->
        </el-form>
        <div class="regist-btn btn" @click="registAccount()">一键注册</div>
        <div class="regist-back btn" @click="toLogin()">返回登录</div>
      </div>
    </div>
  </div>
</template>

<script>
import { FormConfig, TitleConfig, FormValid } from "@/config";
import { validForm, deepClone } from "@/common/utils";
import { loginOrRegister } from "@/api/account";
import { mail_code } from "@/api/common";
import { md5 } from "@/toolUtil/md5";
import cookie from "js-cookie";

export default {
  name: "register",
  data() {
    return {
      ref_regist_form: "ref_regist_form",
      phone_title: "用户注册",
      regist_model: {
        mobilePhone: "",
        code: "",
        password: "",
      },
      rules: {
        mobilePhone: [
          {
            required: true,
            message: "请输入手机号",
            trigger: "blur",
          },
          { validator: this.checkPhone },
        ],
        code: [
          {
            required: true,
            message: "请输入验证码",
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: "请输入密码",
            trigger: "change",
          },
          { validator: FormValid.password },
        ],
        /*_password: [
					{
						required: true,
						message: "请输入重复密码",
						trigger: "change"
					},
					{ validator: FormValid.password }
				]*/
      },
      num: 60,
      timer: null,
      is_login: true,
      isSend: false,
      sendCodeText: "发送验证码",
    };
  },
  created() {
    const num = Number(this.getTimeCookie());
    if (num >= 0) {
      this.num = num;
      this.countDown();
    }
  },
  mounted() {},
  methods: {
    getTimeCookie() {
      return cookie.get(`codeTime`);
    },
    setTimeCookie(time = "60") {
      cookie.set(`codeTime`, time);
    },
    countDown() {
      if (this.num > 0) {
        this.num -= 1;
        this.setTimeCookie(String(this.num));
        this.sendCodeText = `${this.num}秒后`;
        this.timer = setTimeout(this.countDown, 1000);
        this.isSend = true;
      } else {
        this.resetCountDown();
      }
    },
    resetCountDown() {
      clearTimeout(this.timer);
      this.timer = null;
      this.num = 60;
      this.sendCodeText = "发送验证码";
      this.isSend = false;
    },
    sendCode() {
      const reg = /^1[345789]\d{9}$/;
      const { mobilePhone } = this.regist_model;
      if (!reg.test(mobilePhone)) {
        return this.$message.warning("请正确的填写手机号");
      }
      const options = { mobile: mobilePhone, verificationEnums: "REGISTER" };
      mail_code(options).then((res) => {
        if (res) {
          // this.requestId = res;
          this.setTimeCookie();
          // this.setId(res);
          this.countDown();
        }
      });
    },
    async registAccount() {
      const ref = this.$refs.ref_regist_form;
      const is_valid = await validForm(ref);
      if (!is_valid) {
        return this.$message.warning("请填写正确的账号、密码和验证码");
      }
      const { mobilePhone, code, password } = this.regist_model;
      const options = {
        password: md5(password),
        code,
        mobilePhone,
      };
      loginOrRegister(options).then((res) => {
        if (res.data.success) {
          this.$router.push({ name: "Login" });
        } else {
          this.$message.warning(res.data.message);
        }
      });
    },
    toLogin() {
      const params = this.$route.params;
      this.$router.push({ name: "Login", params });
    },
  },
};
/*export default class Login extends Vue {
	@Action("account/verifyPhone") private verifyPhone: any;
	@Action("account/regist") private registRole: any;
	@Action("account/getMail") private getMail: any;
		@Action("account/loginOrRegister") private loginOrRegister: any;
	checkPhone = (rule: any, value: any, callback: any) => {
		const reg = /^1[345789]\d{9}$/;

		if (!reg.test(value)) {
			callback(new Error("请输入11位手机号"));
		} else {
			callback();
		}
	};
	sendCodeText: string = "发送验证码";
	ref_regist_form: string = "ref_regist_form";
	ref_person_form: string = "ref_person_form";
	ref_unit_form: string = "ref_unit_form";
	is_login: boolean = true;
	is_person: boolean = false;
	is_unit: boolean = false;
	isSend: boolean = false;
	phone_title: string = "";
	unit_title: string = "";
	person_title: string = "";
	active: any = 0;
	regist_person_model: any = {
		account: "",
		password: "",
		_password: ""
	};
	regist_unit_model: any = {
		unit_name: "",
		password: "",
		_password: ""
	};
	regist_pre_model: any = {};
	regist_model: any = {
		mobilePhone: "",
		code: "",
		password: "",
		_password: ""
	};
	rules: any = {
		mobilePhone: [
			{
				required: true,
				message: "请输入手机号",
				trigger: "blur"
			},
			{ validator: this.checkPhone }
		],
		code: [
			{
				required: true,
				message: "请输入验证码",
				trigger: "blur"
			}
		],
		password: [
			{
				required: true,
				message: "请输入密码",
				trigger: "change"
			},
			{ validator: FormValid.password }
		],
		_password: [
			{
				required: true,
				message: "请输入重复密码",
				trigger: "change"
			},
			{ validator: FormValid.password }
		]
	};
	rules_person: any = {
		account: [
			{
				required: true,
				message: "请输入账号",
				trigger: "change"
			},
			{ validator: FormValid.account }
		],
		password: [
			{
				required: true,
				message: "请输入密码",
				trigger: "change"
			},
			{ validator: FormValid.password }
		],
		_password: [
			{
				required: true,
				message: "请输入重复密码",
				trigger: "change"
			},
			{ validator: FormValid.password }
		]
	};
	rules_unit: any = {
		unit_name: [
			{
				required: true,
				message: "请输入企业名称",
				trigger: "blur"
			}
		],
		password: [
			{
				required: true,
				message: "请输入密码",
				trigger: "blur"
			},
			{ validator: FormValid.password }
		],
		_password: [
			{
				required: true,
				message: "请输入重复密码",
				trigger: "blur"
			},
			{ validator: FormValid.password }
		]
	};
	regist_radio_type: any = FormConfig.regist_radio_type;
	loginData: any = [];
	addressCode:any = '100000'
	created() {
		const num = Number(this.getTimeCookie());
		if (num >= 0) {
			this.num = num;
			this.requestId = this.getId() as string;
			this.countDown();
		}
		this.getData();
	}
	clearPhoneValid() {
		const ref = this.$refs[this.ref_regist_form];
		(ref as any).resetFields();
	}
	getData() {
		const { regist } = TitleConfig;
		const { mobilePhone, unit, person } = regist;
		this.phone_title = mobilePhone.title;
		this.unit_title = unit.title;
		this.person_title = person.title;
	}
	requestId: string = "";
	private_key: string = "";
	sendCode() {
		const reg = /^1[345789]\d{9}$/;
		const { mobilePhone, nature } = this.regist_model;
		if (!reg.test(mobilePhone)) {
			return this.$message.warning("请正确的填写手机号");
		}
		const options = { mobilePhone, addressCode: this.addressCode };
		this.getMail(options).then((res: any) => {
			if (res) {
				// this.requestId = res;
				this.setTimeCookie();
				// this.setId(res);
				this.countDown();
				return res;
			}
		});
	}
	num: number = 60;
	timer: any = "";
	setId(id: string) {
		cookie.set(`codeId`, id);
	}
	getId() {
		return cookie.get(`codeId`);
	}
	setTimeCookie(time = "60") {
		cookie.set(`codeTime`, time);
	}
	getTimeCookie() {
		return cookie.get(`codeTime`);
	}
	countDown() {
		if (this.num > 0) {
			this.num -= 1;
			this.setTimeCookie(String(this.num));
			this.sendCodeText = `${this.num}秒后`;
			this.timer = setTimeout(this.countDown, 1000);
			this.isSend = true;
		} else {
			this.resetCountDown();
		}
	}
	resetCountDown() {
		clearTimeout(this.timer);
		this.timer = null;
		this.num = 60;
		this.sendCodeText = "发送验证码";
		this.isSend = false;
	}
	async regist() {
		const item = this.$refs.ref_regist_form as any;
		const is_filled = await validForm(item);
		if (!is_filled) {
			return this.$message.warning("请填写手机号和验证码");
		}
		const { mobilePhone, code, password } = this.regist_model;
		const options = {
			mobilePhone,
			code,
			password
		};
		// const private_key = await this.verifyPhone(options);
		// if (!private_key) {
		// 	return false;
		// }
		// this.private_key = private_key;
		this.regist_pre_model = deepClone(this.regist_model);
		this.regist_model = {};
		this.clearPhoneValid();
		this.is_login = false;

	}
	async registAccount() {
		const { mobilePhone, code, nature } = this.regist_pre_model;
		let [accountNumber, unitName, password]: any = [null, null, null];
		let ref = "";
		if (nature === "person") {
			ref = this.ref_person_form;
			let {
				account: act,
				password: psd,
				_password: _psd
			} = this.regist_person_model;
			if (psd !== _psd) {
				return this.$message.warning("请确保两次密码输入一致");
			}
			accountNumber = act;
			// password = btoa(psd);
			password = psd;
		} else if (nature === "unit") {
			ref = this.ref_unit_form;
			let {
				unit_name,
				password: psd,
				_password: _psd
			} = this.regist_unit_model;
			if (psd !== _psd) {
				return this.$message.warning("请确保两次密码输入一致");
			}
			unitName = unit_name;
			// password = btoa(psd);
			password = psd;
		}
		const item = this.$refs[ref] as any;
		const is_filled = await validForm(item);
		if (!is_filled) {
			// return this.$message.warning("请正确的填写表单");
			return;
		}
		// const options = {
		// 	unitName,
		// 	accountNumber,
		// 	password,
		// 	phone,
		// 	code,
		// 	nature,
		// 	requestId: this.requestId,
		// 	privateKey: this.private_key
		// };
		const options2 = {
			company:unitName,
			// password: btoa(password),
			password: password,
			mobilePhone,
			code,
			addressCode: this.addressCode,
			loginOrRegister:1
			// requestId: this.requestId,
			// privateKey: this.private_key
		};
		this.loginOrRegister(options2).then((res: any) => {
			if (res) {
				this.$router.push({ name: "UnitAuthern" });
				// this.toLogin();
				// return this.$message.success("注册成功");
			}
		});
		// this.registRole(options).then((res: any) => {
		// 	if (res) {
		// 		this.toLogin();
		// 		return this.$message.success("注册成功");
		// 	}
		// });
	}
	toLogin() {
		const params = this.$route.params;
		this.$router.push({ name: "Login", params });
	}
}*/
</script>
<style scoped lang="scss">
@import "@/assets/styles/views/regist.scss";
@import "@/assets/styles/components/form.scss";
</style>
